import { SmartTooltip } from '@sdk/common/tooltip/SmartTooltip';
import gettext from '@sdk/lang/gettext';

import { Button, ButtonIcon } from './reactionButton.styles';

type Props = {
  handleClick: () => void;
  isActive?: boolean;
  label?: string;
};

export const ReactionButton = ({ handleClick, isActive = false, label = '' }: Props) => (
  <SmartTooltip content={gettext('React')} disable={isActive}>
    <Button onClick={handleClick} isActive={isActive}>
      {label}
      <ButtonIcon />
    </Button>
  </SmartTooltip>
);
